function markLqipLoaded(img) {
  img.classList.add('is-loaded');
  const wrap = img.closest('.lqip-wrap');
  if (wrap) {
    wrap.classList.add('is-loaded');
  }
}

function initLqip(root) {
  (root || document).querySelectorAll('.lqip-wrap img').forEach(img => {
    if (img.complete && img.naturalHeight !== 0) {
      markLqipLoaded(img);
    } else {
      img.addEventListener('load', () => markLqipLoaded(img), { once: true });
      img.addEventListener('error', () => {
        const wrap = img.closest('.lqip-wrap');
        if (wrap) wrap.classList.add('is-loaded');
      }, { once: true });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initLqip());
} else {
  initLqip();
}

// Product page's model dropdown AJAX-swaps in fresh server HTML — its new
// .lqip-img elements need the same load-tracking wired up.
document.addEventListener('xtron:product-content-swapped', (event) => {
  initLqip(event.detail && event.detail.root);
});
